module.exports = __webpack_public_path__ + "static/media/1f4bb.0200eb56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f4bb.svg
// module id = 633
// module chunks = 1